import React from 'react'

function PaySuccess() {
  return (
    <div>PaySuccess</div>
  )
}

export default PaySuccess